// import file from "../../Assets/doc/pdf/Demo.docx";
let forms = [
  {
    name: "Return of income for block assessment",
    formId: "123-4567-890",
    deadline: "",
    uploaded: "July 13, 21",
    file: "https://res.cloudinary.com/koyosoftwaresolutions/raw/upload/v1637844291/koyo_account_assistant/empty_forms/TAN_New49B_digital_nxyvkm.docx",
    APIEndpoint: "TAN_NEW49BdocxForm",
    desc: "FORM NO. 2B [See rule 12(1A) of Income-tax Rules, 1962] RETURN OF INCOME FOR BLOCK ASSESSMENT ITS-2B (For search and seizure cases) ACKNOWLEDGEMENT",
  },
  {
    name: "Return of income for persons",
    formId: "123-4567-890",
    deadline: "N/A",
    uploaded: "July 13, 21",
    file: "https://res.cloudinary.com/koyosoftwaresolutions/raw/upload/v1637983646/koyo_account_assistant/empty_forms/PAN_49A_kl2czs.docx",
    APIEndpoint: "PAN_49AdocxForm",
    desc: "[I FORM NO. 2C [See rule 12(1)(d) of Income-tax Rules, 1962] RETURN OF INCOME For Persons n not liable to furnish a return of income u/s 139(1) and n residing in such areas",
  },
  {
    name: "Report under section 32(1)(iia) of the Income -tax Act, 1961",
    formId: "3AA",
    deadline: "N/A",
    uploaded: "July 13, 21",
    file: "https://res.cloudinary.com/koyosoftwaresolutions/raw/upload/v1638287735/koyo_account_assistant/empty_forms/TAN_data_Correction_Form_For_allocated_TAN_sdw8ym.docx",
    APIEndpoint: "TAN_CorrectionForm",
    desc: "which has been determined on the basis of new plant and machinery acquired and installed after the 31st day of March, 2002 by the assessee in the new industrial undertaking",
  },
  // {
  //   name: "Audit Report under section 32AB(5)",
  //   formId: "123-4567-890",
  //   deadline: "N/A",
  //   uploaded: "July 13, 21",
  //   file: "",
  //   APIEndpoint: "",
  //   desc: "A further report as required under the proviso to section 32AB(5) is furnished in Part III of this Form In *my/our opinion and to the best of *my/our information and according to",
  // },
  // {
  //   name: "Audit report under section 35D(4)/35E(6) of the Income- tax Act, 1961",
  //   formId: "123-4567-890",
  //   deadline: "N/A",
  //   uploaded: "July 13, 21",
  //   file: "",
  //   APIEndpoint: "",
  //   desc: "FORM NO. 3AE [See rule 6AB] Audit Report under section * 35D(4)/35E(6) of the Income-tax Act, 1961 * I/We have examined the Balance Sheet(s) of M/s In a case where the claim",
  // },
  // {
  //   name: "Report under section 36(1)(xi) of the Income-tax Act, 1961",
  //   formId: "123-4567-890",
  //   deadline: "N/A",
  //   uploaded: "July 13, 21",
  //   file: "",
  //   APIEndpoint: "",
  //   desc: "and such deduction has been correctly claimed in accordance with the provisions of the said clause In my/our * opinion and to the best of my/our * information and according to the",
  // },
];

export default forms;
